<div class="d-flex justify-content-center price-container mb-1">
  <eplus-price-info
    [prefixLabel]="fields().ProductBuyPricePrefixLabel"
    [price]="product().price ?? 0"
    orientation="column"
  />
  <eplus-price-info
    [prefixLabel]="fields().ProductRentPricePrefixLabel"
    [suffixLabel]="suffixLabel()"
    [price]="product().rentPrice ?? 0"
    orientation="column"
  />
</div>
@let installationLabel = fields().InstallationInclusiveLabel;
@if (installationLabel) {
  <span class="installation-notice" *scText="installationLabel"></span>
}
